import React, { useState } from 'react';
import '../styling/SignUp.css'
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import BookingHeader from './clientPortal/BookingHeader';
const CheckMail = () => {
      
      return (
        <div>
        <BookingHeader/>
        <div className='login' style={{ marginTop: '10px', height: "270px"}}>
          <div style={{ padding: '8%'}}>
          <div style={{ fontSize: "20px", color: "#1C1154", textAlign: "center", display: "block", fontWeight: "bold"}}>
             Check your email
             </div>
            <div style={{color: '#625C73', textAlign: "center"}}>
              <p>Please check your email to complete the verification of your account</p>
            </div>

            <Link to="/login">
            <button className="login-button">
              Go Back to login page
            </button></Link>
        
          </div>
        </div>
        </div>
      );
};

export default CheckMail;